"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStorePlatform = exports.valueForBenefitAndLicenceTypes = exports.titleStringForBenefitType = exports.stringsForLicenseType = exports.STORE_LICENSE_BENEFITS = exports.BENEFIT_CHECK = exports.OfferStrings = exports.StoreLicenseBenefit = exports.SUBSCRIPTION_LICENSE_TYPES = exports.StoreLicenseIncludedContent = void 0;
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const i18n_1 = require("@completeanatomy/i18n");
var StoreLicenseIncludedContent;
(function (StoreLicenseIncludedContent) {
    StoreLicenseIncludedContent[StoreLicenseIncludedContent["Atlas"] = 0] = "Atlas";
    StoreLicenseIncludedContent[StoreLicenseIncludedContent["Courses"] = 1] = "Courses";
    StoreLicenseIncludedContent[StoreLicenseIncludedContent["Videos"] = 2] = "Videos";
    StoreLicenseIncludedContent[StoreLicenseIncludedContent["Curriculum"] = 3] = "Curriculum";
})(StoreLicenseIncludedContent || (exports.StoreLicenseIncludedContent = StoreLicenseIncludedContent = {}));
exports.SUBSCRIPTION_LICENSE_TYPES = [
    bridge_schema_1.LicenseType.StudentPlus,
    bridge_schema_1.LicenseType.Pro,
    bridge_schema_1.LicenseType.Edu,
];
var StoreLicenseBenefit;
(function (StoreLicenseBenefit) {
    StoreLicenseBenefit[StoreLicenseBenefit["GrossAnatomyAtlas"] = 0] = "GrossAnatomyAtlas";
    StoreLicenseBenefit[StoreLicenseBenefit["MicroAnatomyAtlas"] = 1] = "MicroAnatomyAtlas";
    StoreLicenseBenefit[StoreLicenseBenefit["CrossPlatformAccess"] = 2] = "CrossPlatformAccess";
    StoreLicenseBenefit[StoreLicenseBenefit["AllVideos"] = 3] = "AllVideos";
    StoreLicenseBenefit[StoreLicenseBenefit["AllCourses"] = 4] = "AllCourses";
    StoreLicenseBenefit[StoreLicenseBenefit["DynamicCrossSections"] = 5] = "DynamicCrossSections";
    StoreLicenseBenefit[StoreLicenseBenefit["PresentationLicense"] = 6] = "PresentationLicense";
    StoreLicenseBenefit[StoreLicenseBenefit["PatientEducationLicense"] = 7] = "PatientEducationLicense";
    StoreLicenseBenefit[StoreLicenseBenefit["SendCurriculimContent"] = 8] = "SendCurriculimContent";
    StoreLicenseBenefit[StoreLicenseBenefit["CurriculimResources"] = 9] = "CurriculimResources";
    StoreLicenseBenefit[StoreLicenseBenefit["CurriculumManager"] = 10] = "CurriculumManager";
    StoreLicenseBenefit[StoreLicenseBenefit["ContentSharingWithLinks"] = 11] = "ContentSharingWithLinks";
})(StoreLicenseBenefit || (exports.StoreLicenseBenefit = StoreLicenseBenefit = {}));
exports.OfferStrings = {
    [bridge_schema_1.LicenseOfferType.Introductory]: i18n_1.Strings.store.offers.introductory,
    [bridge_schema_1.LicenseOfferType.Retaining]: i18n_1.Strings.store.offers.retaining,
};
exports.BENEFIT_CHECK = 'check';
exports.STORE_LICENSE_BENEFITS = [
    StoreLicenseBenefit.GrossAnatomyAtlas,
    StoreLicenseBenefit.MicroAnatomyAtlas,
    StoreLicenseBenefit.CrossPlatformAccess,
    StoreLicenseBenefit.AllVideos,
    StoreLicenseBenefit.AllCourses,
    StoreLicenseBenefit.DynamicCrossSections,
    StoreLicenseBenefit.PresentationLicense,
    StoreLicenseBenefit.PatientEducationLicense,
    StoreLicenseBenefit.SendCurriculimContent,
    StoreLicenseBenefit.CurriculimResources,
    StoreLicenseBenefit.CurriculumManager,
    StoreLicenseBenefit.ContentSharingWithLinks,
];
const stringsForLicenseType = (type) => {
    switch (type) {
        case bridge_schema_1.LicenseType.StudentPlus:
            return i18n_1.Strings.store.licenses.studentPlus;
        case bridge_schema_1.LicenseType.Edu:
            return i18n_1.Strings.store.licenses.educator;
        case bridge_schema_1.LicenseType.Pro:
            return i18n_1.Strings.store.licenses.pro;
        default:
            throw new Error(`Unexpected value: ${type}`);
    }
};
exports.stringsForLicenseType = stringsForLicenseType;
const BENEFIT_STRINGS = {
    [StoreLicenseBenefit.GrossAnatomyAtlas]: {
        title: i18n_1.Strings.store.benefits.titles.grossAnatomyAtlas,
        value: {
            [bridge_schema_1.LicenseType.StudentPlus]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Pro]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
        },
    },
    [StoreLicenseBenefit.MicroAnatomyAtlas]: {
        title: i18n_1.Strings.store.benefits.titles.microAnatomyAtlas,
        value: {
            [bridge_schema_1.LicenseType.StudentPlus]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Pro]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
        },
    },
    [StoreLicenseBenefit.CrossPlatformAccess]: {
        title: i18n_1.Strings.store.benefits.titles.crossPlatformAccess,
        value: {
            [bridge_schema_1.LicenseType.StudentPlus]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Pro]: exports.BENEFIT_CHECK,
        },
    },
    [StoreLicenseBenefit.AllVideos]: {
        title: i18n_1.Strings.store.benefits.titles.allVideos,
        value: {
            [bridge_schema_1.LicenseType.StudentPlus]: i18n_1.Strings.store.benefits.numberOfVideos,
            [bridge_schema_1.LicenseType.Pro]: i18n_1.Strings.store.benefits.numberOfVideos,
            [bridge_schema_1.LicenseType.Edu]: i18n_1.Strings.store.benefits.numberOfVideos,
        },
    },
    [StoreLicenseBenefit.AllCourses]: {
        title: i18n_1.Strings.store.benefits.titles.allCourses,
        value: {
            [bridge_schema_1.LicenseType.StudentPlus]: i18n_1.Strings.store.benefits.numberOfCourses,
            [bridge_schema_1.LicenseType.Pro]: i18n_1.Strings.store.benefits.numberOfCourses,
            [bridge_schema_1.LicenseType.Edu]: i18n_1.Strings.store.benefits.numberOfCourses,
        },
    },
    [StoreLicenseBenefit.DynamicCrossSections]: {
        title: i18n_1.Strings.store.benefits.titles.dynamicCrossSections,
        value: {
            [bridge_schema_1.LicenseType.StudentPlus]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Pro]: exports.BENEFIT_CHECK,
        },
    },
    [StoreLicenseBenefit.PresentationLicense]: {
        title: i18n_1.Strings.store.benefits.titles.presentationLicense,
        value: {
            [bridge_schema_1.LicenseType.Pro]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
        },
    },
    [StoreLicenseBenefit.PatientEducationLicense]: {
        title: i18n_1.Strings.store.benefits.titles.patientEducationLicense,
        value: {
            [bridge_schema_1.LicenseType.Pro]: exports.BENEFIT_CHECK,
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
        },
    },
    [StoreLicenseBenefit.SendCurriculimContent]: {
        title: i18n_1.Strings.store.benefits.titles.sendCurriculimContent,
        value: {
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
        },
    },
    [StoreLicenseBenefit.CurriculimResources]: {
        title: i18n_1.Strings.store.benefits.titles.curriculimResources,
        value: {
            [bridge_schema_1.LicenseType.Edu]: i18n_1.Strings.store.benefits.numberOfCurriculumResources,
        },
    },
    [StoreLicenseBenefit.CurriculumManager]: {
        title: i18n_1.Strings.store.benefits.titles.curriculumManager,
        value: {
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
        },
    },
    [StoreLicenseBenefit.ContentSharingWithLinks]: {
        title: i18n_1.Strings.store.benefits.titles.contentSharingWithLinks,
        value: {
            [bridge_schema_1.LicenseType.Edu]: exports.BENEFIT_CHECK,
        },
    },
};
const titleStringForBenefitType = (type) => BENEFIT_STRINGS[type].title;
exports.titleStringForBenefitType = titleStringForBenefitType;
const valueForBenefitAndLicenceTypes = (benefitType, licenseType) => BENEFIT_STRINGS[benefitType].value[licenseType];
exports.valueForBenefitAndLicenceTypes = valueForBenefitAndLicenceTypes;
//To match back-end Iterable enums.
const storePlatformMap = {
    [bridge_schema_1.Platform.iPhone]: 'iPhone Store',
    [bridge_schema_1.Platform.iOS]: 'iPhone Store',
    [bridge_schema_1.Platform.iPad]: 'iPad Store',
    [bridge_schema_1.Platform.Mac]: 'Mac Store',
    [bridge_schema_1.Platform.Apple]: 'Apple Store',
    [bridge_schema_1.Platform.Android]: 'Google Play Store',
    [bridge_schema_1.Platform.Chromebook]: 'Google Play Store',
    [bridge_schema_1.Platform.Google]: 'Google Play Store',
    [bridge_schema_1.Platform.Windows]: 'Windows Store',
    [bridge_schema_1.Platform.SurfaceHub]: 'Windows Store',
    [bridge_schema_1.Platform.Microsoft]: 'Windows Store',
};
function getStorePlatform(platform) {
    if (platform === undefined) {
        return '';
    }
    return storePlatformMap[platform];
}
exports.getStorePlatform = getStorePlatform;
